// extracted by mini-css-extract-plugin
module.exports = {"btn-round":"ButtonRound_btn-round__1VEPn"};